import React from 'react';
import classnames from 'classnames';
import s from './FeedSidebar.scss';
var FeedSidebar = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.isSticky, isSticky = _b === void 0 ? true : _b, stickyClassName = _a.stickyClassName;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("div", { className: classnames(isSticky && s['sticky'], isSticky && stickyClassName) }, children)));
};
FeedSidebar.displayName = 'FeedSidebar';
export default FeedSidebar;
//# sourceMappingURL=FeedSidebar.js.map